<template>
    <div class="summary upload-content">
        <h4>检测电子文件签名是否被篡改，电子文件是否真实有效</h4>
        <p class="verify-contract">可验证在任意平台签署完成的电子文件</p>
        <el-upload class="upload-verify"
                   drag
                   :before-upload="beforeAvatarUpload"
                   :on-progress="upLoading"
                   :on-success="uploadSuccess"
                   :on-error="uploadError"
                   :show-file-list="false"
                   accept=".pdf,.ofd"
                   :action="url"
                   :multiple="false">
            <svg style="font-size:60px;"
                 class="icon"
                 aria-hidden="true">
                <use xlink:href="#iconofd-gray"></use>
            </svg>
            <svg style="font-size:60px;"
                 class="icon"
                 aria-hidden="true">
                <use xlink:href="#iconpdf1"></use>
            </svg>
            <div class="el-upload__text red-text word-text">{{ uploadStatus }}</div>
            <el-progress v-show="showProgress"
                         :percentage="percentage"
                         :stroke-width="4"
                         status="exception"></el-progress>
        </el-upload>
    </div>
</template>

<script>
import { openDB, addItem } from '@/api/indexedDB';

export default {
    data() {
        return {
            percentage: 0,
            timer: 0,
            uploadStatus: '点击上传已签署的文件',
            showProgress: false, // 展示进度条
        };
    },
    props: {
        hideNavigate: Boolean,
        url: String,
        isUnlogin: Boolean
    },
    methods: {
        // 判断上传格式
        beforeAvatarUpload (file) {
            const isAllowType = file.name.includes('.pdf') || file.name.includes('.ofd');
            const isOverSize = file.size > 30 * 1024 * 1024;

            if (!isAllowType) {
                this.$message.error("上传文件只能是PDF/OFD格式！");
            }
            if (isOverSize) {
                this.$message.error("文件大小不能超过30M！");
            }
            return !isOverSize && isAllowType;
        },
        upLoading (event, file) {
            this.percentage = event.percent;
            this.showProgress = true;
            this.uploadStatus = file.name;
        },
        async uploadSuccess (response, file) {
            if (response.code == 0) {
                this.percentage = 100;
                const db = await openDB('fileDB', 1);
                const id = await addItem(db, 'fileStore', { response: file.response });
                this.$router.push({ name: 'verifyResult', query: {dbId:id, hideNavigate: this.hideNavigate, hideFrame: this.hideNavigate, isUnlogin: this.isUnlogin } });
            } else {
                this.$message.error(response.message);
                this.uploadError();
            }
        },
        // 文件上传失败
        uploadError (error) {
            this.uploadStatus = '点击上传已签署的PDF文件';
            this.showProgress = false;
            this.percentage = 0;
            if (error && error.message) {
                this.$message.error(error.message);
            }
        },
    }
};
</script>
<style lang="less">
.upload-content {
    margin: 40px auto;
    text-align: center;
    .verify-contract {
        font-size: 12px;
        color: @grey;
        margin-bottom: 30px;
        margin-top: 10px;
    }
    .word-text {
        margin-top: 15px;
    }
    .pdf-img {
        font-size: 60px;
        color: @red;
        display: inline-block;
        margin-top: 35px;
    }

    .upload-verify {
        .el-upload-dragger {
            padding-top: 40px;
            background-color: @background-color-primary !important;
            width: 640px;
        }
        .el-icon-circle-close {
            &:before {
                content: "";
            }
        }
    }
}
</style>
